import { createBrowserRouter, Route } from "react-router-dom";
// import RequireAuth from "./ProtectedRoute";

import HomeHybrid from "../views/Home/HomeHybrid";
import DestinatioDetail from "../views/Destination/detail";
import DestinationList from "../views/Destination";
import EventListRedesign from "../views/Event/EventListRedesign";
import EventDetailRedesign from "../views/Event/EventDetailRedesign";
import ProgrammeListRedesign from "../views/Programmes/ProgrammeListRedesign";
import ProgrammeDetailRedesign from "../views/Programmes/ProgrammeDetailRedesign";
import AboutUs from "../views/AboutUs";
import SearchResults from "../views/Search";
import ContactUs from "../views/ContactUs";


const MainRouter = createBrowserRouter([
  {
    path: "/",
    element: <HomeHybrid />,
  },

  {
    path: "/about-us",
    element: <AboutUs />,
  },

  {
    path: "/contact-us",
    element: <ContactUs />,
  },

  {
    path: "/search",
    element: <SearchResults />,
  },

  {
    path: "/destinations",
    element: <DestinationList />,
  },

  {
    path: "country/destinations/:country",
    element: <DestinationList />,
  },

  {
    path: "events",
    element: <EventListRedesign />,
  },

  {
    path: "programmes",
    element: <ProgrammeListRedesign />,
  },

  {
    path: "programmes/:programmeId",
    element: <ProgrammeDetailRedesign />,
  },

  {
    path: "events/:eventId",
    element: <EventDetailRedesign />,
  },

  {
    path: "destinations/:destinationId",
    element: <DestinatioDetail />,
  },

]);

export default MainRouter;
